import { ReactNode } from "react";

/**
 * Passthrough chrome for the reused StudentProfile under the admin detail route. The shared
 * StudentProfileLayout defaults to the students-tab sidebar; under admin that shell is already
 * provided by AdminProtectedRoute, so we render the profile content bare to avoid a double sidebar.
 *
 * Kept in its own tiny module (not the layout) so App.tsx can import it eagerly for the detail
 * route's `chrome` prop without pulling the whole student-management feature into the main bundle —
 * the layout itself is lazy-loaded.
 */
export const StudentProfileNoChrome = ({ children }: Readonly<{ children: ReactNode }>) => (
  <>{children}</>
);
